/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  count: 0,
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};

export const headcountLeavingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.HEADCOUNT_LEAVING + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.HEADCOUNT_LEAVING + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        count: action.result.data.length,
        responseTime: action.result.responseTime,
        isLoading: false,
      };
    case actionType.HEADCOUNT_LEAVING + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
